export default __webpack_public_path__ + "static/media/policyBanner.642a686f.png";